import React, { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaymentCallback({ reference, onDone }) {
  const [status, setStatus] = useState('verifying');
  const [amountPaid, setAmountPaid] = useState(null);

  useEffect(() => {
    if (!reference) {
      setStatus('failed');
      return;
    }
    verifyPayment();
  }, [reference]); // eslint-disable-line react-hooks/exhaustive-deps

  const verifyPayment = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/payments/verify/${reference}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
      });
      const data = await response.json();
      if (data.status === 'success') {
        setStatus('success');
        setAmountPaid(data.amount_paid);
      } else {
        setStatus('failed');
      }
    } catch {
      setStatus('failed');
    }
  };

  const handleDone = () => {
    // Clean up URL and go back to dashboard
    window.history.replaceState({}, '', window.location.pathname);
    if (onDone) onDone();
  };

  return (
    <div data-testid="payment-callback" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#FFF5FB', padding: '2rem'
    }}>
      <div style={{
        background: 'white', borderRadius: '16px', padding: '3rem 2.5rem',
        maxWidth: '480px', width: '100%', textAlign: 'center',
        boxShadow: '0 4px 32px rgba(160,48,106,0.12)'
      }}>
        {status === 'verifying' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
            <h2 style={{ color: '#A0306A', marginBottom: '0.5rem' }}>Verifying Payment</h2>
            <p style={{ color: '#666' }}>Please wait while we confirm your payment...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>✅</div>
            <h2 style={{ color: '#22c55e', marginBottom: '0.5rem' }}>Payment Successful!</h2>
            {amountPaid && (
              <p style={{ fontSize: '1.5rem', fontWeight: '700', color: '#A0306A', margin: '0.5rem 0' }}>
                R{Number(amountPaid).toFixed(2)}
              </p>
            )}
            <p style={{ color: '#666', marginBottom: '2rem' }}>
              Your booking has been paid and confirmed. We'll be in touch shortly.
            </p>
            <button
              data-testid="payment-success-done-btn"
              onClick={handleDone}
              style={{
                background: '#A0306A', color: 'white', border: 'none',
                borderRadius: '10px', padding: '0.85rem 2.5rem',
                fontSize: '1rem', fontWeight: '600', cursor: 'pointer', width: '100%'
              }}
            >
              View My Trips
            </button>
          </>
        )}

        {status === 'failed' && (
          <>
            <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>❌</div>
            <h2 style={{ color: '#dc2626', marginBottom: '0.5rem' }}>Payment Not Completed</h2>
            <p style={{ color: '#666', marginBottom: '2rem' }}>
              Your payment was not completed. Your booking has been saved — you can try paying again from My Trips.
            </p>
            <button
              data-testid="payment-failed-done-btn"
              onClick={handleDone}
              style={{
                background: '#A0306A', color: 'white', border: 'none',
                borderRadius: '10px', padding: '0.85rem 2.5rem',
                fontSize: '1rem', fontWeight: '600', cursor: 'pointer', width: '100%'
              }}
            >
              Back to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
}
